"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProviderError = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _error = require("./error");
class ProviderError extends _error.BasicError {
  constructor(error, data, name) {
    super('Providers API Error', error, data, name);
  }
}
exports.ProviderError = ProviderError;
class BasicProviderApi extends _basic.default {
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      httpGatewayUrl,
      sendWSMessage
    } = _ref;
    super({
      userTokenFactory
    });
    this.providersAccountId = providersAccountId;
    this.sdkApiUrl = sdkApiUrl;
    this.httpGatewayUrl = httpGatewayUrl; // better to use httpGatewayUrl than sdkApiUrl
    this.sendWSMessage = sendWSMessage;
    this.axios = this._createAxios();
  }
  async _callApi(_ref2) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {},
      errorName
    } = _ref2;
    if (this.sendWSMessage) return this._callApiWS({
      method,
      path,
      payload,
      queryParams,
      errorData,
      errorName
    });
    return this._callApiHttp({
      method,
      path,
      payload,
      queryParams,
      errorData,
      errorName
    });
  }
  async _callApiHttp(_ref3) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {},
      errorName
    } = _ref3;
    const {
      headers
    } = await this.getHeaders();
    try {
      const {
        data: responseBody
      } = await this.axios({
        method,
        url: path,
        data: JSON.stringify(payload),
        params: _lodash.default.mapValues(queryParams, value => _lodash.default.isArray(value) ? JSON.stringify(value) : value),
        headers
      });
      return responseBody;
    } catch (error) {
      throw new ProviderError(error, {
        statusCode: _lodash.default.get(error, ['response', 'status']),
        config: _lodash.default.get(error, ['response', 'config']),
        headers: _lodash.default.get(error, ['response', 'headers']),
        ...errorData
      }, errorName);
    }
  }
  async _callApiWS(_ref4) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {},
      errorName
    } = _ref4;
    let {
      headers
    } = await this.getHeaders();
    headers = _lodash.default.mapKeys(headers, (val, key) => _lodash.default.toLower(key));
    path = _lodash.default.replace(path, /^\//, '');
    const message = {
      event: {
        target: this.providersAccountId,
        name: `http/${method}/${path}`,
        params: {
          method,
          path,
          request: {
            method,
            headers,
            queryParams,
            body: payload
          }
        }
      }
    };
    try {
      const timeoutError = new Error('Timeout');
      timeoutError.response = {
        config: {
          method,
          baseURL: 'WS',
          url: path,
          data: payload,
          params: queryParams
        }
      };
      const response = await this.sendWSMessage({
        message,
        timeoutError
      });
      const code = _lodash.default.get(response, ['result', 'code']);
      const body = _lodash.default.get(response, ['result', 'body']);
      if (code >= 400) {
        const errorMessage = _lodash.default.get(body, ['error'], 'API Error');
        const err = new Error(errorMessage);
        err.response = {
          status: code,
          data: body,
          headers: _lodash.default.get(response, ['result', 'headers']),
          config: {
            method,
            baseURL: 'WS',
            url: path,
            data: payload,
            params: queryParams
          }
        };
        throw err;
      }
      return body;
    } catch (error) {
      throw new ProviderError(error, {
        statusCode: _lodash.default.get(error, ['response', 'status']),
        config: _lodash.default.get(error, ['response', 'config']),
        headers: _lodash.default.get(error, ['response', 'headers']),
        ...errorData
      }, errorName);
    }
  }
  _createAxios() {
    let {
      baseUrl
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const providersApiUrl = this.httpGatewayUrl ? `${this.httpGatewayUrl}/${encodeURIComponent(this.providersAccountId)}` : `${this.sdkApiUrl}/http/${encodeURIComponent(this.providersAccountId)}`;
    return _axios.default.create({
      baseURL: baseUrl || providersApiUrl
      // timeout : 10000
    });
  }
}
var _default = BasicProviderApi;
exports.default = _default;